// @flow
import {CodeSnippetGeneratedCodeBlock} from 'docs/components';

export type State = {
  resource: string,
  action: string,
  params: Object,
  pathArgs: {
    [string]: string,
  },
  codegenExample?: ?{
    generatedCodeBlocks?: Array<CodeSnippetGeneratedCodeBlock>,
    error?: string,
  },
  apiResponse?: ?{
    response?: Object,
    error?: string,
  },
};

export const createInitialState = (): State => ({
  resource: '',
  action: '',
  params: {},
  pathArgs: {},
});

export const initialState = createInitialState();

export type SetResourceAction = {|
  type: 'SET_RESOURCE',
  payload: $PropertyType<State, 'resource'>,
|};

export type SetActionAction = {|
  type: 'SET_ACTION',
  payload: $PropertyType<State, 'action'>,
|};

export type SetParamsAction = {|
  type: 'SET_PARAMS',
  payload: $PropertyType<State, 'params'>,
|};

export type SetPathArgsAction = {|
  type: 'SET_PATH_ARGS',
  payload: $PropertyType<State, 'pathArgs'>,
|};
export type SetCodegenExampleAction = {|
  type: 'SET_CODEGEN_EXAMPLE',
  payload: $PropertyType<State, 'codegenExample'>,
|};

export type SetApiResponseAction = {|
  type: 'SET_API_RESPONSE',
  payload: $PropertyType<State, 'apiResponse'>,
|};

export type Action =
  | SetResourceAction
  | SetActionAction
  | SetParamsAction
  | SetPathArgsAction
  | SetCodegenExampleAction
  | SetApiResponseAction;

export const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'SET_RESOURCE':
      return {
        ...state,
        resource: action.payload,
        action: '',
        pathArgs: {},
        params: {},
        codegenExample: null,
        apiResponse: null,
      };
    case 'SET_ACTION':
      return {
        ...state,
        action: action.payload,
        pathArgs: {},
        params: {},
        codegenExample: null,
        apiResponse: null,
      };
    case 'SET_PARAMS':
      return {
        ...state,
        params: action.payload,
        codegenExample: null,
        apiResponse: null,
      };
    case 'SET_PATH_ARGS':
      return {
        ...state,
        pathArgs: action.payload,
        codegenExample: null,
        apiResponse: null,
      };
    case 'SET_CODEGEN_EXAMPLE':
      return {
        ...state,
        codegenExample: action.payload,
      };
    case 'SET_API_RESPONSE':
      return {
        ...state,
        apiResponse: action.payload,
      };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};
